const currentWindowOrigin = window.location.origin

export default {
    REGION: 'eu-west-1',
    USER_POOL_ID: 'eu-west-1_pbICIzEPV',
    USER_POOL_APP_CLIENT_ID: '283e3eac55vt8cf3nm3n9vmrgi',
    REDIRECT_SIGN_IN: currentWindowOrigin,
    DOMAIN: 'admin-central-production.auth.eu-west-1.amazoncognito.com',
}
